<template>
  <div>
    <center>
      <v-overlay :value="dataReady">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-img height="100%" :src="imageQuest"></v-img>
      <v-container fluid>
        <v-row dense>
          <!-- <v-col cols="12">
            <v-card>
              <center>
                <v-card-text>
                  <div>Word of the Day</div>
                  <p class="text-h4 text--primary">รูปภาพ</p>
                  <p>adjective</p>
                  <div class="text--primary">
                    relating to or dependent on charity; charitable.
                  </div>
                </v-card-text>
              </center>
            </v-card>
          </v-col> -->
          <v-col cols="12">
            <div v-if="dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
        </v-row>
        <template v-if="!dataReady">
          <v-card class="mx-auto my-2 text-left" elevation="12">
            <v-card-text>
              <div class="text--primary">
                1) คุณมีอุณหภูมิร่างกายตั้งแต่ 37.5 องศาขึ้นไป
                หรือตัวร้อนแบบมีไข้ หรือไม่
              </div>
            </v-card-text>
            <v-card-text>
              <center>
                <v-chip-group
                  active-class="deep-purple accent-4 white--text text-center"
                  column
                  v-model="selection1"
                  style="margin-left: 25%"
                >
                  <v-chip v-on:click="form.formSaveRisk1 = 1">ใช่ (Yes)</v-chip>

                  <v-chip v-on:click="form.formSaveRisk1 = 0"
                    >ไม่ใช่ (None)</v-chip
                  >
                </v-chip-group>
              </center>
            </v-card-text>
          </v-card>
          <v-card class="mmx-auto my-2 text-left" elevation="12">
            <v-card-text>
              <div class="text--primary">
                2) คุณมีอาการอย่างใดอย่างหนึ่ง จากรายการดังต่อไปนี้ <br />
                (เลือกได้มากกว่า 1) (ไม่พบอาการใดๆ ไม่ต้องเลือก)
              </div>
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <v-checkbox
                    v-model="selection21"
                    label="ไอ"
                    color="red"
                    value="ไอ"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="selection21"
                    label="มีน้ำมูก"
                    color="red darken-3"
                    value="มีน้ำมูก"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="selection21"
                    label="เจ็บคอ"
                    color="indigo"
                    value="เจ็บคอ"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="selection21"
                    label="คันคอ"
                    color="indigo"
                    value="คันคอ"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="selection21"
                    label="เจ็บหน้าอก"
                    color="orange"
                    value="เจ็บหน้าอก"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="selection21"
                    label="ปวดศรีษะ"
                    color="orange darken-3"
                    value="ปวดศรีษะ"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="selection21"
                    label="หายใจเร็ว หรือ หายใจลำบาก"
                    color="indigo darken-3"
                    value="หายใจเร็ว หรือ หายใจลำบาก"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="selection21"
                    label="จมูกไม่ได้กลิ่น"
                    color="red"
                    value="จมูกไม่ได้กลิ่น"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="selection21"
                    label="มีผื่นแดง"
                    color="red darken-3"
                    value="มีผื่นแดง"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="selection21"
                    label="ท้องเสีย"
                    color="indigo"
                    value="ท้องเสีย"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="mx-auto my-2 text-left" elevation="12">
            <v-card-text>
              <div class="text--primary">
                3) ในช่วง 10 วัน
                คุณมีประวัติสัมผัสบุคคล(ความเสี่ยงสูง)ที่ใกล้ชิดกับผู้ติดเชื้อ
                COVID-19 ใช่หรือไม่
              </div>
            </v-card-text>
            <v-card-text>
              <center>
                <v-chip-group
                  active-class="deep-purple accent-4 white--text text-center"
                  column
                  v-model="selection3"
                  style="margin-left: 25%"
                >
                  <v-chip v-on:click="form.formSaveRisk3 = 1">ใช่ (Yes)</v-chip>

                  <v-chip v-on:click="form.formSaveRisk3 = 0"
                    >ไม่ใช่ (None)</v-chip
                  >
                </v-chip-group>
              </center>
            </v-card-text>
          </v-card>
          <v-card class="mx-auto my-2 text-left" elevation="12">
            <v-card-text>
              <div class="text--primary">
                4) คุณมีบุคคลภายในครอบครัวที่พักอาศัยร่วมกัน
                เสี่ยงสัมผัสกับผู้ติดเชื้อ COVID-19 ในช่วง 10 วันใช่หรือไม่
              </div>
            </v-card-text>
            <v-card-text>
              <center>
                <v-chip-group
                  active-class="deep-purple accent-4 white--text text-center"
                  column
                  v-model="selection4"
                  style="margin-left: 25%"
                >
                  <v-chip v-on:click="form.formSaveRisk4 = 1">ใช่ (Yes)</v-chip>

                  <v-chip v-on:click="form.formSaveRisk4 = 0"
                    >ไม่ใช่ (None)</v-chip
                  >
                </v-chip-group>
              </center>
            </v-card-text>
          </v-card>
          <v-card class="mx-auto my-2 text-left" elevation="12">
            <v-card-text>
              <div class="text--primary">
                5. ในช่วงระยะเวลา 3-5 วันที่ผ่านมา ท่านมีประวัติเดินทางไปสถานที่
                ทีมีการรวมกลุ่มคน หรือชุมชน เช่น ตลาดนัด ห้างสรรพสินค้า
                สถานพยาบาล หรือ ขนส่งสาธารณะใช่ หรือไม่
              </div>
            </v-card-text>
            <v-card-text>
              <center>
                <v-chip-group
                  active-class="deep-purple accent-4 white--text text-center"
                  column
                  v-model="selection5"
                  style="margin-left: 25%"
                >
                  <v-chip v-on:click="form.formSaveRisk5 = 1">ใช่ (Yes)</v-chip>

                  <v-chip v-on:click="form.formSaveRisk5 = 0"
                    >ไม่ใช่ (None)</v-chip
                  >
                </v-chip-group>
              </center>
            </v-card-text>
          </v-card>
          <v-card class="mx-auto my-2 text-left" elevation="12">
            <v-card-text>
              <div class="text--primary">
                6) ในช่วง 10 วัน คุณมีประวัติการสัมผัส หรือ ใกล้ผู้ป่วย Covid 19
                มากกว่า 5 นาที ใช่หรือไม่
              </div>
            </v-card-text>
            <v-card-text>
              <center>
                <v-chip-group
                  active-class="deep-purple accent-4 white--text text-center"
                  column
                  v-model="selection6"
                  style="margin-left: 25%"
                >
                  <v-chip v-on:click="form.formSaveRisk6 = 1">ใช่ (Yes)</v-chip>

                  <v-chip v-on:click="form.formSaveRisk6 = 0"
                    >ไม่ใช่ (None)</v-chip
                  >
                </v-chip-group>
              </center>
            </v-card-text>
          </v-card>
          <v-card class="mx-auto my-2 text-left" elevation="12">
            <v-card-text>
              <div class="text--primary">
                7) คุณเป็นผู้ป่วย Covid 19 ใช่หรือไม่
              </div>
            </v-card-text>
            <v-card-text>
              <center>
                <v-chip-group
                  active-class="deep-purple accent-4 white--text text-center"
                  column
                  v-model="selection7"
                  style="margin-left: 25%"
                >
                  <v-chip v-on:click="form.formSaveRisk7 = 1">ใช่ (Yes)</v-chip>

                  <v-chip v-on:click="form.formSaveRisk7 = 0"
                    >ไม่ใช่ (None)</v-chip
                  >
                </v-chip-group>
              </center>
            </v-card-text>
          </v-card>
          <v-row v-if="locationStatus">
            <v-col cols="12">
              <v-btn  v-if="checkAfterCheckIN" color="success" dark block large @click="assessmentUser()"
                >ประเมิน<v-icon right dark>
                  mdi-clipboard-text
                </v-icon></v-btn
              >
            </v-col>
          </v-row>
        </template>
      </v-container>
    </center>
  </div>
</template>
<script>
import covidSelect from '../../assets/master/covid/covidSelect.json'
import axios from 'axios'
import moment from 'moment'
export default {
  components: {
    // gmapApi
  },
  name: 'Info',
  beforeCreate () {
    this.$liff.init({ liffId: this.$liff_risk_assessment }, function (data) {})
  },
  data () {
    return {
      //   session: this.$session.getAll(),
      //   sheet: false,
      center: {},
      date: '',
      profile: [],
      shiftItem: [],
      checkItem: [],
      placeId: '',
      geocoder: null,
      dialog_checkin_success: false,
      dialog_checkout_success: false,
      selection1: 1,
      selection2: 1,
      selection21: [],
      selection3: 1,
      selection4: 1,
      selection5: 1,
      selection6: 1,
      selection7: 1,
      form: {
        userLineuserId: '',
        userIDCard: '',
        userType: '',
        displayNameTh: '',
        userPhone: '',
        formSaveRisk1: 0,
        formSaveRisk2: 0,
        formSaveRisk21: [],
        formSaveRisk3: 0,
        formSaveRisk4: 0,
        formSaveRisk5: 0,
        formSaveRisk6: 0,
        formSaveRisk7: 0,
        formSaveRisk8: 0,
        // ที่อยู่
        locationLat: '',
        locationLong: '',
        // สี
        COLOR: ''
      },
      resultList: covidSelect,
      dataReady: true,
      AccessKey: '',
      ApplicationKey: '',
      checkAfterCheckIN: true,
      imageQuest: '',
      gen_action: '',
      locationStatus: true
    }
  },
  async mounted () {
    // Get Line Profile
    this.imageQuest = require('@/assets/Icon/Quest.jpg')
    this.dataReady = false
    await this.geolocate()
    await this.checkLiffLogin()
  },
  methods: {
    async geolocate () {
      // this.locationStatus = true
      await navigator.geolocation.getCurrentPosition(
        async (position) => {
          const center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          if (center) {
            this.center = center
            this.dataReady = false
            this.locationStatus = true
            console.log('this.center', center)
          }
        },
        (error) => {
          this.dataReady = false
          this.center.lat = null
          this.center.lng = null
          this.locationStatus = true
          console.log('this.center err: ', this.center)
          console.log('error map :', error.message)
        }
      )
      console.log('locatio', this.center)
      this.locationStatus = true
    },
    // Check ENV
    async checkLiffLogin () {
      await this.$liff.ready.then(async () => {
        if (process.env.NODE_ENV === 'development') {
          this.getProfile_dev()
        } else {
          if (!this.$liff.isLoggedIn()) {
            this.$liff.login({ redirectUri: window.location })
          } else {
            await this.getProfile()
          }
        }
      })
    },
    async getProfile () {
      let _this = this
      await this.$liff
        .getProfile()
        .then(async (profileLine) => {
          _this.form.userLineuserId = profileLine.userId
          // _this.form.userLinepictureUrl = profileLine.pictureUrl
          // console.log('profile', _this.form)
          // alert(profileLine.userId)
          await _this.getDataEmp(_this.form)
        })
        .catch(function (error) {
          alert('Error getting profile: ' + error)
        })
    },
    async getProfile_dev () {
      let _this = this
      _this.form.userLineuserId = _this.main_profile.userLineuserId
      await _this.getDataEmp(_this.form)
    },
    // Getting Employee Info
    async getDataEmp (dt) {
      this.dataReady = true
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_user/lineid?userLineuserId=' +
            dt.userLineuserId
        )
        .then(async (response) => {
          this.dataReady = false
          console.log(response.data[0])
          if (response.data[0].empCode) {
            this.profile = response.data[0]
          } else {
            this.$swal(
              'ไม่พบรหัสพนักงาน',
              'คุณไม่มีสิทธิ์เข้าใช้ระบบ กรุณาติดต่อฝ่ายบุคคล',
              'error'
            )
            this.$router.push('/Liff/LoginRisk')
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // ไม่พบรหัสพนักงาน
          this.dataReady = false
          this.$router.push('/Liff/LoginRisk')
        })
    },
    async assessmentUser () {
      this.checkAfterCheckIN = false
      if (this.profile.empCode) {
        this.dataReady = true
        this.form.formSaveRisk2 = 0
        // console.log('selection21', this.selection21.length)
        if (this.selection21.length > 0) {
          this.form.formSaveRisk2 = 1
          this.form.formSaveRisk21 = JSON.stringify(this.selection21)
        } else {
          this.form.formSaveRisk21 = null
        }

        var Risk78 = 0

        await this.resultList.forEach(async (element, index) => {
          Risk78 = (this.form.formSaveRisk7 === 1 || this.form.formSaveRisk8 === 1) ? 1 : 0
          if (
            element.fever === this.form.formSaveRisk1 &&
          element.one_uri_symp === this.form.formSaveRisk2 &&
          element.travel_risk_country === this.form.formSaveRisk3 &&
          element.covid19_contact === this.form.formSaveRisk4 &&
          element.close_risk_location === 0 &&
          element.close_risk_country === this.form.formSaveRisk5 &&
          element.int_contact === this.form.formSaveRisk6 &&
          element.med_prof === Risk78 &&
          element.close_con === Risk78
          ) {
            switch (element.risk_level) {
              case 1:
                this.form.COLOR = 'สีเขียว'
                break
              case 2:
                this.form.COLOR = 'สีเหลือง'
                break
              case 3:
                this.form.COLOR = 'สีส้ม'
                break
              case 4:
                this.form.COLOR = 'สีส้ม'
                break
              case 5:
                this.form.COLOR = 'สีแดง'
                break
            }

            if (this.form.formSaveRisk7 === 1) {
              this.form.COLOR = 'สีแดง'
            }
            this.gen_action = element.gen_action
          }
        })

        var dataRisk = {
          formSaveRisk1: this.form.formSaveRisk1 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk2: this.form.formSaveRisk2 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk3: this.form.formSaveRisk3 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk4: this.form.formSaveRisk4 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk5: this.form.formSaveRisk5 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk6: this.form.formSaveRisk6 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk7: this.form.formSaveRisk7 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk8: this.form.formSaveRisk8 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk21: this.form.formSaveRisk21,
          Lat: this.center.lat,
          Long: this.center.lng,
          COLOR: this.form.COLOR,
          empCode: this.profile.empCode,
          userLineuserId: this.form.userLineuserId,
          year: moment().format('YYYY'),
          month: moment().format('MM'),
          day: moment().format('D')
        }

        await this.updateDisable(dataRisk)

        console.log(dataRisk)
      } else {
        alert('ไม่พบข้อมูลพนักงาน')
        location.reload()
      }
    },
    async _assessmentUser () {
      this.dataReady = true
      this.form.formSaveRisk2 = 0
      // console.log('selection21', this.selection21.length)
      if (this.selection21.length > 0) {
        this.form.formSaveRisk2 = 1
        this.form.formSaveRisk21 = JSON.stringify(this.selection21)
      } else {
        this.form.formSaveRisk21 = null
      }

      this.resultList.forEach(element => {

      })
      for (let key in this.resultList) {
        var result = this.resultList[key]
        var Risk78 = 0
        if (this.form.formSaveRisk7 === 1 || this.form.formSaveRisk8 === 1) {
          Risk78 = 1
        }
        if (
          result.fever === this.form.formSaveRisk1 &&
          result.one_uri_symp === this.form.formSaveRisk2 &&
          result.travel_risk_country === this.form.formSaveRisk3 &&
          result.covid19_contact === this.form.formSaveRisk4 &&
          result.close_risk_location === 0 &&
          result.close_risk_country === this.form.formSaveRisk5 &&
          result.int_contact === this.form.formSaveRisk6 &&
          result.med_prof === Risk78 &&
          result.close_con === Risk78
        ) {
          console.log('result json:', result)
          switch (result.risk_level) {
            case 1:
              this.form.COLOR = 'สีเขียว'
              break
            case 2:
              this.form.COLOR = 'สีเหลือง'
              break
            case 3:
              this.form.COLOR = 'สีส้ม'
              break
            case 4:
              this.form.COLOR = 'สีส้ม'
              break
            case 5:
              this.form.COLOR = 'สีแดง'
              break
          }

          if (this.form.formSaveRisk7 === 1) {
            this.form.COLOR = 'สีแดง'
          }

          this.gen_action = result.gen_action

          // var resultText =
          // '<h4>ความเสี่ยงระดับ: <b>' + this.form.COLOR + '</b></h4>' +
          // '<h6>ข้อแนะนำ: ' + result.gen_action + '</h6>'

          // if (result.spec_action !== '') {
          //   resultText += '<h6>ข้อควรปฏิบัติ: ' + result.spec_action + '</h6>'
          // }

          var dataRisk = {
            formSaveRisk1: this.form.formSaveRisk1 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk2: this.form.formSaveRisk2 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk3: this.form.formSaveRisk3 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk4: this.form.formSaveRisk4 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk5: this.form.formSaveRisk5 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk6: this.form.formSaveRisk6 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk7: this.form.formSaveRisk7 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk8: this.form.formSaveRisk8 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk21: this.form.formSaveRisk21,
            Lat: this.center.lat,
            Long: this.center.lng,
            COLOR: this.form.COLOR,
            empCode: this.profile.empCode,
            userLineuserId: this.form.userLineuserId,
            year: moment().format('YYYY'),
            month: moment().format('MM'),
            day: moment().format('D')
          }

          // console.log(dataRisk)
          // console.log(moment().format('HH'))
          // console.log(moment().format('mm'))
          // const pictureColor = this.checkColor(this.form.COLOR)

          // try {
          //   this.$swal({
          //     text: 'ผลการประเมิน ' + this.form.COLOR,
          //     type: 'warning',
          //     showCancelButton: false,
          //     confirmButtonText: 'รับทราบ'
          //   })
          //     .then(async (result) => {
          alert('ผลการประเมิน ' + this.form.COLOR)
          await this.updateDisable(dataRisk)
          // })
          // .catch((error) => {
          //   console.log(error)
          //   this.$liff.closeWindow()
          // })

          // this.$swal({
          //   title: '<strong>ผลการประเมิน</strong>',
          //   imageUrl: pictureColor,
          //   html: resultText,
          //   allowOutsideClick: false
          // })
          //   .then(async (response) => {
          //     if (response) {
          //       alert('7')
          //       await this.updateDisable(dataRisk)
          //     }
          //   })
          // // eslint-disable-next-line handle-callback-err
          //   .catch((error) => {
          //     alert('7 error')
          //     this.dataReady = false
          //   // this.errored = true
          //   })
          // } catch (error) {
          //   alert('6 error')
          //   alert(error)
          // }
        }
      }
    },
    checkColor (color) {
      var colorLevel = ''
      if (color === 'สีเขียว') {
        colorLevel = 'Green'
      }
      if (color === 'สีเหลือง') {
        colorLevel = 'Yellow'
      }
      if (color === 'สีส้ม') {
        colorLevel = 'Orange'
      }
      if (color === 'สีแดง') {
        colorLevel = 'Red'
      }
      var urlPic = '/static/img/' + colorLevel + '.jpg'
      return urlPic
    },
    async updateDisable (dataRisk) {
      if (this.$liff.getContext().type !== 'none' && this.$liff.getContext().type !== 'external') {
        const result = await axios.post(this.DNS_IP + '/rick_assessment/addAndUpdateDisable', dataRisk)
        if (result.data.status) {
          await this.sendingLiffToLine(dataRisk)
          await this.linenotify(dataRisk)
          await this.$liff.openWindow({
            url: 'https://liff.line.me/1654154168-JML0KbN5?page=AssessmentHistory'
          })
        }
      }
    },
    async sendingLiffToLine (ds) {
      var image = 'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2FCovid%2FGreen.jpg?alt=media'
      var colorLavel = '008000'
      if (this.form.COLOR === 'สีเหลือง') {
        image = 'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2FCovid%2FYellow.jpg?alt=media'
        colorLavel = 'FFD700'
      }
      if (this.form.COLOR === 'สีส้ม') {
        image = 'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2FCovid%2FOrange.jpg?alt=media'
        colorLavel = 'FFA500'
      }
      if (this.form.COLOR === 'สีแดง') {
        image = 'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2FCovid%2FRed.jpg?alt=media'
        colorLavel = 'FF4500'
      }
      await this.$liff.sendMessages([{
        'type': 'text',
        'text': 'ประเมินความเสี่ยงคุณได้สี ' + this.form.COLOR
      },
      {
        'type': 'flex',
        'altText': 'ประเมินความเสี่ยงคุณได้สี ' + this.form.COLOR,
        'contents': {
          'type': 'bubble',
          'body': {
            'type': 'box',
            'layout': 'vertical',
            'contents': [
              {
                'type': 'image',
                'url': image,
                'size': '100%',
                'gravity': 'center'
              }
            ],
            'paddingAll': '0px'
          },
          'footer': {
            'type': 'box',
            'layout': 'vertical',
            'contents': [
              {
                'type': 'box',
                'layout': 'vertical',
                'contents': [
                  {
                    'type': 'text',
                    'text': this.form.COLOR,
                    'wrap': true,
                    'align': 'center',
                    'size': '28px',
                    'weight': 'bold',
                    'color': '#' + colorLavel
                  }
                ],
                'margin': '10px'
              },
              {
                'type': 'box',
                'layout': 'vertical',
                'contents': [
                  // {
                  //   'type': 'text',
                  //   'text': this.profile.empFull_NameTH,
                  //   'wrap': true,
                  //   'align': 'center'
                  // },
                  {
                    'type': 'text',
                    'text': 'ได้ทำการประเมินเรียบร้อย',
                    'wrap': true,
                    'align': 'center'
                  },
                  {
                    'type': 'text',
                    'wrap': true,
                    'align': 'center',
                    'text': 'วันที่ ' + moment().format('DD') + '/' + moment().format('MM') + '/' + moment().format('YYYY') + ' เวลา ' + moment().format('HH') + ':' + moment().format('mm'),
                    'size': '14px'
                  }
                ],
                'margin': '10px'
              },
              {
                'type': 'box',
                'layout': 'vertical',
                'contents': [
                  {
                    'type': 'text',
                    'text': 'ข้อแนะนำ',
                    'wrap': true,
                    'align': 'center'
                  },
                  {
                    'type': 'text',
                    'text': this.gen_action,
                    'wrap': true,
                    'align': 'center'
                  }
                ],
                'margin': '12px'
              },
              {
                'type': 'button',
                'action': {
                  'type': 'uri',
                  'label': 'ตรวจสอบประวัติ',
                  'uri': 'line://app/1654154168-JML0KbN5?page=AssessmentHistory'
                },
                'adjustMode': 'shrink-to-fit',
                'style': 'secondary',
                'margin': '10px'
              }
            ]
          }
        }

      }]).then(function () {
        alert('ประเมินเรียบร้อย')
      }).catch(function (error) {
        console.log(error)
        alert(error)
        // this.dataReady = false
      })

      return true
      // await this.linenotify(ds)

      // await this.$liff.openWindow({
      //   url: 'https://liff.line.me/1654154168-JML0KbN5?page=AssessmentHistory'
      // })
    },
    addZeroBefore (n) {
      return (n < 10 ? '0' : '') + n
    },
    async linenotify (dt) {
      // console.log()
      // alert(dt.COLOR)
      if (dt.COLOR === 'สีส้ม' || dt.COLOR === 'สีแดง') {
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/line_notify_covid/get?notifyCovidType=แจ้งเตือนประเมินความเสี่ยง",
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            this.dataReady = true
            // console.log(response.data.captionName)
            response.data.forEach(async data => {
              console.log(data.notifyCovidToken)
              var textRisk = ''
              if (dt.formSaveRisk1 === 'ใช่') { textRisk += '\n 😷 มีอุณหภูมิกายตั้งแต่ 37.5 องศาขึ้นไป หรือตัวร้อนแบบมีไข้' }
              if (dt.formSaveRisk2 === 'ใช่') { textRisk += '\n 😷 ' + dt.formSaveRisk21 }
              if (dt.formSaveRisk3 === 'ใช่') { textRisk += '\n 😷 มีประวัติเดินทางไปยัง หรือ มาจาก พื้นที่เกิดโรค COVID-19 ในช่วงเวลา 10 วัน ก่อน' }
              if (dt.formSaveRisk4 === 'ใช่') { textRisk += '\n 😷 มีบุคคลภายในครอบครัวที่พักอาศัยร่วมกันติดเชื้อ COVID-19 ในช่วง 10 วัน' }
              if (dt.formSaveRisk5 === 'ใช่') { textRisk += '\n 😷 มีประวัติเดินทางไปสถานที่ที่มีการรวมกลุ่มคน หรือ ชุมชน เช่น ตลาดนัด ห้างสรรพสินค้า สถานพยาบาล หรือ ขนส่งสาธารณะ' }
              if (dt.formSaveRisk6 === 'ใช่') { textRisk += '\n 😷 มีประวัติการสัมผัส หรือ ใกล้ผู้ป่วย Covid 19 เป็นมากกว่า 5 นาที' }
              if (dt.formSaveRisk7 === 'ใช่') { textRisk += '\n 😷 เป็นผู้ป่วย Covid 19' }

              const today = new Date()
              const time = today.getHours() + ':' + today.getMinutes()
              var massageNoti = 'พบผู้มีความเสี่ยงติดโควิดระดับ' + this.form.COLOR +
            '\n\nชื่อผู้ประเมิน : ' + this.profile.empFull_NameTH +
            '\nแผนก : ' + this.profile.masDepartmentName +
            '\nสาขา : ' + this.profile.masBranchName +
            '\nบริษัท : ' + this.profile.masCompanyName +
            '\nเบอร์โทรศัพท์ติดต่อ : ' + this.profile.empTel +
            '\nวันที่ประเมิน : ' + 'วันที่ ' + today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear() + ' เวลา ' + time +
            '\n\nความเสี่ยงที่พบ : ' + textRisk

              var ds = {
                token: data.notifyCovidToken,
                message: massageNoti
              }

              await axios
                .post(
                // eslint-disable-next-line quotes
                  this.DNS_IP + "/line/hrm_notify",
                  ds, {
                    headers: {
                      'Application-Key': localStorage.getItem('ApplicationKey')
                    }
                  }
                )
                .then(async (response) => {
                  console.log(response)
                })
              // eslint-disable-next-line handle-callback-err
                .catch((error) => {
                  console.log('linenotify: ', error)
                })
            })
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            // this.dataReady = true
            console.log(error)
          })
      }
    },
    liffcloseWindow () {
      this.$liff.closeWindow()
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/RiskAssessment.vue